<template>
  <div>
    <div v-if="loading">
      <amenity-manatee-loading></amenity-manatee-loading>
    </div>
    <div v-else>
      <div class="row">
        <div class="form-group col-sm-5 col-md-2">
          <label>Package Price Type</label>

          <select id="package-price-filter" class="form-control" v-validate="'required'"
            v-model="selectedPackagePriceType" name="packagePriceTypeFilter">
            <option value="">-</option>
            <option v-for="packagePriceType in packagePriceTypes" :value="packagePriceType.Id" :key="packagePriceType.Id">
              {{ packagePriceType.Name }}
            </option>
          </select>
        </div>


        <div class="form-group col-sm-5 col-md-3">
          <label>Company</label>

          <select id="select-company" class="form-control" v-validate="'required'" v-model="selectedCompany"
            name="packagePriceTypeFilter">
            <option value="">-</option>
            <option v-for="company in companies" :value="company.id" :key="company.id">
              {{ company.name }}
            </option>
          </select>
        </div>

        <div class="form-group col-sm-5 col-md-3">
          <label>CSM</label>

          <select id="select-CSM" class="form-control" v-validate="'required'" v-model="selectedCSM"
            name="packagePriceTypeFilter">
            <option value="">-</option>
            <option v-for="csm in csms" :value="csm.id" :key="csm.id">
              {{ csm.first_name }} {{ csm.last_name }}
            </option>
          </select>
        </div>
        <div class="form-group col-sm-5 col-md-2">
          <label for="leadTime">Lead Time Days</label><br />
          <div class="input-group">
            <input id="request-amount" class="form-control" min="0" max="730" name="request-amount" type="number"
              v-model="leadTime">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-5 col-md-2">
          <div class="input-group">
            <input type="checkbox" id="include-withdrawn" v-model="includePending" />
            <label for="include-withdrawn"> Include Pending </label>
          </div>
        </div>
      </div>
      <dl class="dashboard-dl">
        <div class="container-fluid">
          <div v-for="priceIntervalStatus in this.priceIntervalStatuses" :key="priceIntervalStatus.Id">
            <div v-if="priceIntervalStatus.Id > 1 || includePending">
              <div class="row">
                <div class="col-sm-12">
                  <core-price-interval-all-by-status :status_id="priceIntervalStatus.Id"
                    :status_name="priceIntervalStatus.Name" :package_price_type_id="selectedPackagePriceType"
                    :company_id="selectedCompany" :csm="selectedCSM" :leadTime="leadTime">
                  </core-price-interval-all-by-status>
                </div>
              </div>
            </div>
          </div>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
import CorePriceIntervalAllByStatus from "./CorePriceIntervalAllByStatus.vue";
export default {
  components: { CorePriceIntervalAllByStatus },
  props: {},
  mounted() {
    this.loadPackagePriceTypes();
    this.loadCompanies();
    this.loadCSMs();
    this.loadPriceInterval()
      .catch(this.$root.handleErrors)
      .finally(() => {
        this.loading = false;
        //window.location = "?test=hello";
      });
  },

  methods: {
    loadPackagePriceTypes() {
      console.log("loadPackagePriceTypes");
      var url = "/core/packagePrice/types";
      console.log(url);
      return axios.get(url).then((response) => {
        console.log(response.data);
        this.$set(this, "packagePriceTypes", response.data);
      });
    },
    loadPriceInterval() {
      var url = "/core/priceInterval/intervalStatuses";
      console.log(url);
      return axios.get(url).then((response) => {
        //console.log(response.data.IntervalStatuses);
        this.$set(
          this,
          "priceIntervalStatuses",
          response.data.IntervalStatuses
        );
        this.loading = false;
      });
    },
    loadCompanies() {
      var url = "/api/companies?sort_by=name&sort_dir=asc";
      console.log(url);
      return axios.get(url).then((response) => {
        //console.log(response.data.IntervalStatuses);
        this.$set(
          this,
          "companies",
          response.data.Companies
        );
        this.loading = false;
      });
    },
    loadCSMs() {
      var url = "/core/community/csmList";
      console.log(url);
      return axios.get(url).then((response) => {
        //console.log(response.data.IntervalStatuses);
        this.$set(
          this,
          "csms",
          response.data
        );
        this.loading = false;
      });
    },
  },
  computed: {},
  data() {
    return {
      loading: true,
      includePending: false,
      priceIntervalStatuses: null,
      packagePriceTypes: null,
      selectedPackagePriceType: null,
      selectedCompany: null,
      selectedCSM: null,
      companies: null,
      csms: null,
      leadTime: 90,
    };
  },
};
</script>
